












import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		isHorizontal: Boolean,
	},
	setup() {
		return {};
	},
});
